import { gql } from "@apollo/client";

export const MUTATION_CREATE_USER_OFFER = gql`
  mutation CreateUserOffer($offerId: ID!) {
    createUserOffer(offerId: $offerId) {
      id
    }
  }
`;
